import './LeaseCategoryCard.css';

/**
 * LeaseCategoryCard (Andys #1108). Плитка категории лизинга: обложка-фото над
 * единой серой полосой-подвалом (тип сверху / "from €X +VAT/mo" под ним).
 * Выбор красит полосу и обводку в красный (--widget-primary) и чуть
 * приподнимает карточку. Все значения — widget/theme CSS-переменные (с
 * fallback) для Shadow-DOM.
 *
 * Кнопка-переключатель (`aria-pressed`), а не радио (#1469): повторный тап по
 * выбранной карточке снимает выбор, а радио «отжать» нельзя. Группу с подписью
 * (`role="group"` + `aria-label`) задаёт родитель.
 *
 * @param {object}   props
 * @param {string}   [props.image]     обложка-фото категории
 * @param {string}   props.label       название категории (Economy / City / …)
 * @param {number}   props.priceFrom   минимальная цена, EUR/мес (без VAT)
 * @param {boolean}  [props.selected]  выбрана ли карточка
 * @param {Function} [props.onClick]   клик по карточке
 */
export const LeaseCategoryCard = ({
  image,
  label,
  priceFrom,
  selected = false,
  onClick,
  ...rest
}) => (
  <button
    type="button"
    aria-pressed={selected}
    className={`lease-cat${selected ? ' lease-cat--selected' : ''}`}
    onClick={onClick}
    {...rest}
  >
    {image && (
      <img
        className="lease-cat__photo"
        src={image}
        alt=""
        loading="lazy"
        aria-hidden="true"
      />
    )}
    <span className="lease-cat__bar">
      <span className="lease-cat__type">{label}</span>{' '}
      {/* Цена — две неразрывные группы: «from €250» и «+VAT/mo». Если на
          узкой карточке (2 колонки на 320px) им тесно в одной строке, вторая
          группа переносится целиком, а не рвётся по пробелу (#1469). */}
      <span className="lease-cat__price">
        <span className="lease-cat__amount">
          <small>from</small> €{priceFrom}
        </span>{' '}
        <small className="lease-cat__vat">+VAT/mo</small>
      </span>
    </span>
  </button>
);

export default LeaseCategoryCard;
